<template>
  <div class="ti">
    <div class="displays">
      <div style="width: 500px">
        <!-- <el-input class="inputs" placeholder="输入关键字进行搜索" v-model="filterText"></el-input> -->
        <el-tree
          class="filter-tree"
          :data="data"
          :props="defaultProps"
          @node-click="clickOk"
          :filter-node-method="filterNode"
          ref="tree"
        >
        </el-tree>
      </div>
      <div class="cdj_add" v-if="distinguish != ''">
        <el-card class="box-card">
          <div class="text item">
            <el-tabs
              v-model="activeName"
              @tab-click="handleClick"
              style="margin-top: -17px"
            >
              <el-tab-pane
                :label="label0"
                name="first"
                v-if="distinguish != 10"
              >
                <el-form ref="form" :model="form" label-width="80px">
                  <el-form-item label="操作类型" v-if="distinguish == 1">
                    <el-radio-group v-model="resource">
                      <el-radio label="架构修改"></el-radio>
                      <el-radio label="添加架构"></el-radio>
                      <el-radio label="添加部门"></el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item :label="label1">
                    <el-input
                      v-model="form.jname"
                      placeholder="填写架构名称"
                    ></el-input>
                  </el-form-item>
                  <el-form-item :label="label2">
                    <el-input
                      v-model="form.jremarks"
                      placeholder="选填"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="复用权限">
                    <el-select
                      v-model="treeFuOen"
                      filterable
                      placeholder="复用权限"
                      style="width: 100%"
                    >
                      <div v-for="item in treeFus" :key="item.id">
                        <el-option
                          :label="item['jname']"
                          :value="item['id']"
                        ></el-option>
                      </div>
                    </el-select>
                  </el-form-item>
                  <el-form-item :label="label3" class="cdj_tree">
                    <div class="text item">
                      <el-tree
                        :data="tree"
                        show-checkbox
                        ref="tree"
                        node-key="id"
                        includeHalfChecked="false"
                        :default-expanded-keys="defaultcheckedkeyssa"
                        :default-checked-keys="defaultcheckedkeys"
                      >
                      </el-tree>
                    </div>
                  </el-form-item>
                  <el-form-item>
                    <el-button
                      size="mini"
                      type="primary"
                      @click="onSubmit(1)"
                      style="color: #ffffff"
                      >立即保存</el-button
                    >
                  </el-form-item>
                </el-form>
              </el-tab-pane>

              <el-tab-pane :label="tabname" name="third">
                <el-form ref="form" :model="user" label-width="80px">
                  <el-form-item label="登录账号">
                    <el-input
                      v-model="user.user"
                      placeholder="可填写姓名作为登录账号"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="登录密码">
                    <el-input
                      v-model="user.pwd"
                      placeholder="密码留空不修改"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="联系电话">
                    <el-input
                      v-model="user.phone"
                      placeholder="填写联系电话"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="人员权限">
                    <el-select
                      v-model="user.jurisdiction_id"
                      filterable
                      placeholder="请选择权限"
                      style="width: 100%"
                    >
                      <div v-for="item in jusers" :key="item.id">
                        <el-option
                          :label="item['jname']"
                          :value="item['id']"
                        ></el-option>
                      </div>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-button
                      size="mini"
                      type="primary"
                      @click="onSubmit(2)"
                      style="color: #ffffff"
                      >立即保存</el-button
                    >
                  </el-form-item>
                </el-form>
              </el-tab-pane>
            </el-tabs>
          </div>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
import tree from "../../../assets/js/tree";
export default {
  name: "Jlist",
  data() {
    return {
      defaultcheckedkeys: [],
      defaultcheckedkeyssa: [],
      tabname: "添加人员",
      filterText: "",
      data: [],
      label0: "编辑架构",
      label1: "架构名称",
      label2: "架构备注",
      label3: "架构权限",
      defaultProps: {
        children: "children",
        label: "label",
      },
      resource: "架构修改",
      tree: [],
      activeName: "first",
      form: {
        jname: "",
        jremarks: "",
      },
      user: {
        jurisdiction_id: "",
        user: "",
        pwd: "",
        phone: "",
      },
      treeFus: [],
      jurisdiction: [],
      types: 1,
      jusers: [],
      distinguish: "",
      treeFuOen: "",
    };
  },
  //界面没出来前加载
  created() {},
  // 加载数据
  mounted() {
    // this.tree = tree;
    //加载公司权限列表
    var login = window.localStorage.getItem("login");
    this.$myhttp
      .get("admin/getJlist?login=" + login, {
        "Content-Type": "application/json",
      })
      .then((backdata) => {
        // 异步执行成功后
        if (backdata.data[1] == 2) {
          this.tree = backdata.data[0];
        } else {
          this.tree = JSON.parse(JSON.stringify(this.__MENU_LIST__)); //tree;
        }
      });
    //加载复用权限
    this.$Loading.start();
    this.$myhttp
      .get("admin/treeFu", {
        "Content-Type": "application/json",
      })
      .then((backdata) => {
        // 异步执行成功后
        this.treeFus = backdata.data.data;
        this.$Loading.finish();
      });
    this.$myhttp
      .get("admin/jurisdictionList", {
        "Content-Type": "application/json",
      })
      .then((backdata) => {
        // 异步执行成功后
        this.data = backdata.data.data;
      });
  },
  computed: {
    __MENU_LIST__() {
      return ERP.getStore().__MENU_LIST__;
    },
  },
  //事件
  methods: {
    //搜索过滤节点
    filterNode(value, data) {
      if (!value) return true;
      // return data.label.indexOf(value) !== -1;
    },
    //被点击时触发
    clickOk(data) {
      this.types = 1;
      var distinguish = data.distinguish;
      var id = data.id;
      this.distinguish = distinguish;
      if (distinguish == 10) {
        this.tabname = "编辑人员";
        this.activeName = "third";
      } else {
        if (distinguish == 0) {
          this.label0 = "编辑部门";
          this.label1 = "部门名称";
          this.label2 = "部门备注";
          this.label3 = "部门权限";
        } else {
          this.label0 = "编辑架构";
          this.label1 = "架构名称";
          this.label2 = "架构备注";
          this.label3 = "架构权限";
        }

        this.activeName = "first";
        this.tabname = "添加人员";
        this.user = {
          jurisdiction_id: "",
          user: "",
          pwd: "",
          phone: "",
        };
      }
      this.$Loading.start();
      var datas = {
        id: id,
        distinguish: distinguish,
        company_id: data.company_id,
      };
      this.jurisdiction = data; //保存请求数据，提交保存的时候用到
      this.$myhttp
        .post("admin/juserTreeid", datas, {
          "Content-Type": "application/json",
        })
        .then((backdata) => {
          // 异步执行成功后
          this.$Loading.finish();
          var data = backdata.data;
          if (distinguish != 10) {
            this.form = data.data;
            this.resource = "架构修改";
            this.defaultcheckedkeys = data.selective;
            this.$refs.tree.setCheckedKeys([data.selective]);
          } else {
            this.user = data.data;
            this.user.pwd = "";
          }
          this.jusers = data.jusers;
          this.$forceUpdate();
          // console.log(datas);
        });
    },
    //编辑切换
    handleClick(tab, event) {
      // console.log(tab.$options.propsData);
    },
    trres() {
      //加载复用权限
      this.$Loading.start();
      this.$myhttp
        .get("admin/treeFu", {
          "Content-Type": "application/json",
        })
        .then((backdata) => {
          // 异步执行成功后
          this.treeFus = backdata.data.data;
          this.$Loading.finish();
        });
      this.$myhttp
        .get("admin/jurisdictionList", {
          "Content-Type": "application/json",
        })
        .then((backdata) => {
          // 异步执行成功后
          this.data = backdata.data.data;
        });
    },
    //提交
    onSubmit(type) {
      if (type == 1) {
        var datas = this.form; //架构
        var id = this.$refs.tree.getCheckedKeys(); //获得全选状态id
        var ids = this.$refs.tree.getHalfCheckedKeys(); //获得半选状态的id
        var listid = id.concat(ids); //数组组合
        listid.sort(); //排序
        var jurisdiction = this.jurisdiction;
        // console.log(jurisdiction);
        if (this.resource == "架构修改") {
          var distinguish = 1;
          var jid = jurisdiction.id;
        } else {
          var jid = "";
        }
        if (this.resource == "添加架构") {
          var distinguish = 1;
        }
        if (this.resource == "添加部门") {
          var distinguish = 0;
          if (datas.jname == "") {
            this.$Message.error("部门名称不能为空!");
            return false;
          }
        } else {
          if (datas.jname == "") {
            this.$Message.error("架构名称不能为空!");
            return false;
          }
        }
        var data = {
          id: jid,
          company_id: jurisdiction.company_id,
          jurisdiction_id: jurisdiction.id,
          distinguish: distinguish,
          jname: datas.jname,
          jremarks: datas.jremarks,
          listid: listid,
        };

        this.$Loading.start();
        this.$myhttp
          .post("admin/jurListAdd", data, {
            "Content-Type": "application/json",
          })
          .then((backdata) => {
            // 异步执行成功后
            if (backdata.data.code == 202) {
              this.$Message.error(backdata.data.data);
            } else {
              this.form = {
                jname: "",
                jremarks: "",
                region: "",
              };
              this.treeFuOen = "";
              this.$refs.tree.setCheckedKeys([]);
              this.$Message.success("操作成功");
              this.trres();
            }
            this.$Loading.finish();
            this.$forceUpdate();
          });
      } else {
        //人员
        var data = this.user;
        if (data.user == "") {
          this.$Message.error("登录账号不能为空!");
          return false;
        }
        if (data.phone == "") {
          this.$Message.error("联系电话不能为空!");
          return false;
        }
        if (data.jurisdiction_id == "") {
          this.$Message.error("人员权限不能为空!");
          return false;
        }
        var jurisdiction = this.jurisdiction;
        if (jurisdiction.distinguish == 10) {
          data["jusers"] = this.jusers;
          this.$Loading.start();
          this.$myhttp
            .post("admin/jurListUserAdd", data, {
              "Content-Type": "application/json",
            })
            .then((backdata) => {
              // 异步执行成功后
              if (backdata.data.code == 202) {
                this.$Message.error(backdata.data.data);
              } else {
                this.user = {
                  jurisdiction_id: "",
                  user: "",
                  pwd: "",
                  phone: "",
                };
                this.$Message.success("操作成功");
                this.trres();
              }
              this.$Loading.finish();
              this.$forceUpdate();
            });
        } else {
          var jusers = this.jusers;
          var data = {
            company_id: jurisdiction.company_id,
            jurisdiction_id: data.jurisdiction_id,
            user: data.user,
            pwd: data.pwd,
            phone: data.phone,
            jusers: jusers,
          };
          this.$Loading.start();
          this.$myhttp
            .post("admin/jurListUserAdd", data, {
              "Content-Type": "application/json",
            })
            .then((backdata) => {
              // 异步执行成功后
              if (backdata.data.code == 202) {
                this.$Message.error(backdata.data.data);
              } else {
                this.user = {
                  jurisdiction_id: "",
                  user: "",
                  pwd: "",
                  phone: "",
                };
                this.$Message.success("操作成功");
                this.trres();
              }
              this.$Loading.finish();
              this.$forceUpdate();
            });
        }
      }
      // console.log(data);
    },
  },
  watch: {
    filterText(val) {
      // console.log(val)
      this.$refs.tree.filter(val);
    },
    resource(val) {
      this.treeFuOen = "";
      if (val == "架构修改") {
        this.label1 = "架构名称";
        this.label2 = "架构备注";
        this.label3 = "架构权限";
        if (this.types == 2) {
          this.types = 1;
          this.clickOk(this.jurisdiction);
        }
      }
      if (val == "添加架构") {
        this.label1 = "架构名称";
        this.label2 = "架构备注";
        this.label3 = "架构权限";
        this.types = 2;
        this.defaultcheckedkeys = [];
        this.$refs.tree.setCheckedKeys([]);
        this.form = {
          jname: "",
          jremarks: "",
          region: "",
        };
      }
      if (val == "添加部门") {
        this.label1 = "部门名称";
        this.label2 = "部门备注";
        this.label3 = "部门权限";
        this.types = 2;
        this.defaultcheckedkeys = [];
        this.$refs.tree.setCheckedKeys([]);
        this.form = {
          jname: "",
          jremarks: "",
          region: "",
        };
      }
    },
    //监听复用权限修改
    treeFuOen(val) {
      if (val) {
        this.$Loading.start();
        this.$myhttp
          .get("admin/treeFus?id=" + val, {
            "Content-Type": "application/json",
          })
          .then((backdata) => {
            // 异步执行成功后
            this.$refs.tree.setCheckedKeys(backdata.data.data);
            this.$Loading.finish();
          });
      }
    },
  },
};
</script>
<style scoped>
.ti {
  margin: 1%;
  width: 100%;
  height: 98%;
  overflow: scroll;
}
.displays {
  display: flex;
}
.inputs {
  margin-bottom: 10px;
}
.cdj_add {
  margin-left: 70px;
}

.text {
  font-size: 14px;
}
.item {
  padding: 0 0;
}
.box-card {
  width: 600px;
  height: 760px;
}
.cdj_tree {
  height: 350px;
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Jurisdiction/Jlist.vue